import {
    useAppDispatch,
    useAppSelector,
} from "../../../store/hooks/StoreHooks";
import {
    GKXPumpCalculationInputs,
    ChargePumpCalculationInputs,
} from "../../../store/model/calculations/calculation";
import {
    setGasHandlerData,
    setGasHandlerPumpID,
    setShowGkxGraphControl,
    resetGasHandlerCalculation,
    setGasHandlerPumpName,
    setGKXCalculationData,
    setCP1CalculationData,
    setCP2CalculationData,
    setCP3CalculationData,
} from "../../../store/calculation/calculation-output/gasHandlerSlice";

export const useGasHandlerFacade = () => {
    const dispatch = useAppDispatch();

    const resetGasHandlerValues = () => {
        return dispatch(resetGasHandlerCalculation());
    };

    const updateShowGkxGraphControl = (payload: boolean) => {
        return dispatch(setShowGkxGraphControl(payload));
    };

    const updateGKXDataHandler = (payload: any) => {
        return dispatch(setGasHandlerData(payload));
    };

    const updateGasHandlerPumpID = (value: string) => {
        return dispatch(setGasHandlerPumpID(value));
    };

    const updateGasHandlerPumpName = (name: string) => {
        return dispatch (setGasHandlerPumpName(name));
    };

    const updateGKXCalculationData = (payload: any) => {
        return dispatch(setGKXCalculationData(payload));
    };

    const updateCP1CalculationData = (payload: any) => {
        return dispatch(setCP1CalculationData(payload));
    };

    const updateCP2CalculationData = (payload: any) => {
        return dispatch(setCP2CalculationData(payload));
    };

    const updateCP3CalculationData = (payload: any) => {
        return dispatch(setCP3CalculationData(payload));
    };

    return {
        resetGasHandlerValues,
        updateShowGkxGraphControl,
        updateGasHandlerPumpID,
        updateGKXDataHandler,
        updateGasHandlerPumpName,
        updateGKXCalculationData,
        updateCP1CalculationData,
        updateCP2CalculationData,
        updateCP3CalculationData,
    };
};
